import React, { useState, useRef, Fragment } from "react";
import verify from "../../media/verify.png";
import clock from "../../media/clock.png";
import eth from "../../media/eth.png";
import eye from "../../media/eye.png";
import heart from "../../media/heart.png";

const ShowcasedDetailCard = (props:{metaverseName: string, postedDate: string, propertyName: string, price: string, views: string, likes: string}) => {
  return (
    <>    
    <div className="w-72 h-52 relative bottom-32 left-80 overflow-hidden rounded-lg bg-white drop-shadow-xl">
      <div className="grid  grid-col-2 grid-rows-4 px-4 py-5 sm:p-6">
        <div className=" grid grid-flow-col inline-grid">
          <h2 className="text-sm text-slate-400 italic font-bold">
            {props.metaverseName}
          </h2>
          <img className="relative right-4" src={verify} />
          <img className="relative left-4" src={clock} />
          <h2 className="text-sm text-slate-400 font-bold">{props.postedDate}</h2>
        </div>
        <div className="w-full relative bottom-8">
          <p className="text-lg text-black font-semibold">
            {props.propertyName}
          </p>
        </div>
        <div className="grid grid-flow-row ">
          <div>
            <p className="text-sm text-slate-500 font-semibold">For Sale</p>
          </div>
          <div className="grid grid-flow-col place-content-start">
            <img className="" src={eth} />
            <p className="cursor-default pointer-events-none text-xl text-logo-green font-bold ml-2">
                {props.price}
            </p>
            <div className="inline-grid grid-flow-col place-content-start ml-8">
              <img className="" src={eye} />
              <p className="cursor-default pointer-events-none text-md text-black font-medium relative left-2">
                {props.views}
              </p>
              <img className="relative left-6" src={heart} />
              <p className="cursor-default pointer-events-none text-md text-black font-medium relative left-8">
                {props.likes}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};
export default ShowcasedDetailCard;
